import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from "@angular/core";
import { TranslateModule } from "@ngx-translate/core";
import { Thread, ThreadAuthor } from "@teammood/timeline";
import { ThreadInputAreaComponent } from "../thread-input-area/thread-input-area.component";
import { AsyncPipe, CommonModule, NgClass } from "@angular/common";
import { LinkPreviewComponent } from "../../../shared/ui/linkpreview/linkpreview";
import { BreakpointObserver, Breakpoints } from "@angular/cdk/layout";
import { distinctUntilChanged, map } from "rxjs";
import { MatTooltip, MatTooltipModule } from "@angular/material/tooltip";
import { TmPipesModule } from "../../../shared/util/pipes";
import { MatMenuModule } from "@angular/material/menu";
import { UsernameIconComponent } from "../../../shared/ui/username-icon/username-icon.component";
import { UserInfos } from "../../../shared/ui/username-icon/user-infos.type";

@Component({
    selector: 'tm-thread-message',
    templateUrl: './thread-message.component.html',
    styleUrls: ['./thread-message.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [
        TranslateModule,
        LinkPreviewComponent,
        AsyncPipe,
        NgClass,
        MatTooltip,
        ThreadInputAreaComponent,
        TmPipesModule,
        MatMenuModule,
        UsernameIconComponent,
        MatTooltipModule,
        CommonModule
    ]
})
export class ThreadMessageComponent {
    @Input() thread: Thread;

    @Input() threadAuthors: ThreadAuthor[];

    @Input() timelineItemId: string;

    @Input()
    disableActions: boolean = false;

    protected threadUpdateMode: boolean = false;

    protected showThreadActions: boolean = false;

    protected isHandset =  this.breakpointObserver.observe([
        Breakpoints.Handset,
    ]).pipe(
        map(result => result.matches),
        distinctUntilChanged()
    )

    @Output()
    private onThreadDeleted = new EventEmitter<Thread>();
    @Output()
    private onThreadReported = new EventEmitter<Thread>();
    @Output()
    private onThreadEdited = new EventEmitter<Thread>();

    constructor(private breakpointObserver: BreakpointObserver) {
    }

    protected onMouseDetect(inside: boolean){
        this.showThreadActions = inside;
    }

    protected editThread(){
        this.threadUpdateMode = true;
    }

    protected onEditedThread(thread: Thread){
        this.onThreadEdited.next(thread);
        this.threadUpdateMode = false;
    }

    protected delete(thread: Thread){
        this.onThreadDeleted.next(thread);
    }

    protected report(thread: Thread){
        this.onThreadReported.next(thread);
    }

    protected cancelUpdate() {
        this.threadUpdateMode = false;
    }

    protected userInfos(): UserInfos {
        return new UserInfos(this.thread.author.firstname, this.thread.author.lastname)
    }

    protected readonly UserInfos = UserInfos;
}